import * as Yup from 'yup';

const schema = Yup.object({});

export default schema;
